import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class DateSelectedService {
  private dateSelectedSource = new Subject<string>();
  private bannerExitIconClickInEnterBalancesSource = new Subject<string>();
  private bannerExitIconClickInReviewAndCommit = new Subject<string>();

  dateSelected$ = this.dateSelectedSource.asObservable();
  bannerExitClickInEnterBalances$ = this.bannerExitIconClickInEnterBalancesSource.asObservable();
  bannerExitClickInReviewAndCommit$ = this.bannerExitIconClickInReviewAndCommit.asObservable();

  broadcastDateSelected(dateSelected: any) {
    this.dateSelectedSource.next(dateSelected);
  }

  broadcastExitIconClickInEnterBalances(exitClicked: any) {
    this.bannerExitIconClickInEnterBalancesSource.next(exitClicked);
  }

  broadcastExitIconClickInReviewAndCommit(exitClicked: any) {
    this.bannerExitIconClickInReviewAndCommit.next(exitClicked);
  }
}
